export default __webpack_public_path__ + "static/invoice-deliverables-d4d875559094b04738f16dc6f7ad9136.png";